import { Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { ProtectedRoute } from './components/ProtectedRoute'
import LoginPage from './pages/LoginPage'
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'
import DashboardPage from './pages/DashboardPage'
import ConfigurationPage from './pages/ConfigurationPage'
import UsersPage from './pages/UsersPage'
import AuditLogsPage from './pages/AuditLogsPage'
import MobileClientLogsPage from './pages/MobileClientLogsPage'
import PublicChatLogsPage from './pages/PublicChatLogsPage'
import BusinessesPage from './pages/BusinessesPage'
import BusinessSettingsPage from './pages/BusinessSettingsPage'
import SubscriptionsPage from './pages/SubscriptionsPage'
import CompanySubscriptionsPage from './pages/CompanySubscriptionsPage'
import SupportManagementPage from './pages/SupportManagementPage'
import MarketingCampaigns from './pages/MarketingCampaigns'
import MarketingContacts from './pages/MarketingContacts'
import MarketingTemplatesPage from './pages/MarketingTemplatesPage'
import LeadsPage from './pages/LeadsPage'
import GlobalAgentsPage from './pages/GlobalAgentsPage'
import ServiceFlowReviewsPage from './pages/ServiceFlowReviewsPage'
import PayrollDocumentationPage from './pages/docs/PayrollDocumentationPage'
import Layout from './components/Layout'

function App() {
  return (
    <AuthProvider>
      <div className="min-h-screen bg-gray-50">
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <Layout>
                  <Routes>
                    <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/configuration" element={<ConfigurationPage />} />
            <Route path="/users" element={<UsersPage />} />
            <Route path="/audit-logs" element={<AuditLogsPage />} />
            <Route path="/mobile-client-logs" element={<MobileClientLogsPage />} />
            <Route path="/public-chats" element={<PublicChatLogsPage />} />
            <Route path="/businesses" element={<BusinessesPage />} />
            <Route path="/businesses/:id/settings" element={<BusinessSettingsPage />} />
            <Route path="/leads" element={<LeadsPage />} />
            <Route path="/subscriptions" element={<SubscriptionsPage />} />
            <Route path="/company-subscriptions" element={<CompanySubscriptionsPage />} />
            <Route path="/support-management" element={<SupportManagementPage />} />
            <Route path="/marketing/campaigns" element={<MarketingCampaigns />} />
            <Route path="/marketing/contacts" element={<MarketingContacts />} />
            <Route path="/marketing/templates/:businessId?" element={<MarketingTemplatesPage />} />
            <Route path="/global-agents" element={<GlobalAgentsPage />} />
            <Route path="/reviews" element={<ServiceFlowReviewsPage />} />
            <Route path="/docs/payroll" element={<PayrollDocumentationPage />} />
                  </Routes>
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </div>
    </AuthProvider>
  )
}

export default App
